import { render, staticRenderFns } from "./CoSAllocation.vue?vue&type=template&id=73bdd6dd&lang=pug"
import script from "./CoSAllocation.vue?vue&type=script&lang=ts"
export * from "./CoSAllocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports